define(function (require) {
	var _ = require('lodash');

	var _oMissingKeys = {};

	var i18n = {};

	var i18nDataField = document.getElementById('i18nData');
	if (i18nDataField != null) {
		i18n = JSON.parse(i18nDataField.value);
	}
	else {
		// le field i18nData est volontairement omis sur les sites seulement en FR
		// console.log("Le field i18nData est manquant (devrait être dans _Layout.vbhtml à la fin du body)");
	}

	if (i18n == null) i18n = {};

	i18n.lang = 'fr-FR'//deprecated, utiliser i18n.culture() ou i18n.locale(). 
	i18n.trans = function (raw, vars) {
		var tmpPrototypes;
		var translatedString = replaceEscapedCharacters(raw).split("|");
		var text = null;

		if (translatedString.length > 1) {

			var counter = findCounter(vars);

			if (counter !== null && vars != null) {
				var i = 0;

				for (var i in translatedString) {
					text = contextualizedTrans(translatedString[i], counter, i);
					if (text !== null)
						break;
				}

				if (text === null)
					text = "{ [i18n] ERROR: The translator couldn't find a suitable translate with the provided counter (counter: <samp>" + counter + "</samp>, plainText: <samp>" + raw + "</samp>).}";
			}
			else
				text = "{ [i18n] ERROR: Counter not found.}";
		}
		else
			text = translatedString[0];

		if (text !== null) {
			text = reverseEscapedCharacters(text);
			text = fillVars(text, vars);
			return text.trim();
		}

		return null;

		function isNumeric(n) { return !isNaN(parseFloat(n)) && isFinite(n); }

		function findCounter(vars) {
			if (vars != null) {
				for (var key in vars)
					if (key.trim().charAt(0) == '>' && isNumeric(String(vars[key]).trim()))
						return parseInt(String(vars[key]).trim());
				if (Object.keys(vars).length == 1 && isNumeric(String(vars[Object.keys(vars)[0]]).trim()))
					return parseInt(vars[Object.keys(vars)[0]]);
				if (typeof vars.count !== 'undefined' && isNumeric(String(vars.count).trim()))
					return vars.count;
			}
			return null;
		}

		function contextualizedTrans(translatedString, count, index) {
			if (count !== null) {
				/*var m, regex = /^\s*([\[\]{])([^}\[\]]+)([\]\[}])\s*(.*)$/g;*/
				var m, regex = /(.*?)?\s*([\[\]{])([^}\[\]]+)([\]\[}])\s*(.*?)?$/g;
				if ((m = regex.exec(translatedString)) !== null) {
					var SS = m[2];
					var ES = m[4];
					var sNumericSet = m[3];
					var sText = (typeof m[5] == 'undefined') ? m[1] : m[5];
					if (SS == '{') {
						for (var val in sNumericSet.split(','))
							if (val == count)
								return (sText == '') ? ' ' : sText;
					}
					else {
						var LN = sNumericSet.split(',')[0];
						var RN = sNumericSet.split(',')[1];
						if (isNumeric(LN) && isNumeric(RN) && ((SS == ']' && (count > LN) || (SS == '[' && count >= LN)) && ((ES == ']' && count <= RN) || (ES == '[' && count < RN))))
							return sText;
						else if (isNumeric(LN) && !isNumeric(RN) && ((SS == "]" && count > LN) || (SS == "[" && count >= LN)))
							return sText;
						else if (!isNumeric(LN) && isNumeric(RN) && ((ES == "]" && count <= RN) || (ES == "[" && count < RN)))
							return sText;
						else if (!isNumeric(LN) && !isNumeric(RN))
							return sText;
					}
					return null;
				}
				return (pluralIndex(count) == index) ? translatedString : null;
			}
			return null;
		}

		function replaceEscapedCharacters(text) {
			if (text != null) {
				/* Problem: can't find a way to replace "\\|" and "\|" properly o_O... */
				//text = text.split('\\|').join('::KEEPBACKSLASH::|');
				//text = text.split('\|').join('::KEEPVERTICALBAR::');

				// Some functions or variables may contain the character | but we don't want them to split the text so var's replace them and keep them in memory
				tmpPrototypes = {};
				var constText = text, m, regex = /_\(\s*\"[^"]+"\s*,?\s*[^)]*\s*\)/g;
				while ((m = regex.exec(constText)) !== null) {
					tmpPrototypes['::VAR' + m.index + '::'] = m[0];
					text = text.replace(m[0], '::VAR' + m.index + '::');
				}
			}

			return text;
		}

		function reverseEscapedCharacters(text) {
			//text = text.split('::KEEPBACKSLASH::').join('\\');
			//text = text.split('::KEEPVERTICALBAR::').join('|');

			for (var i in tmpPrototypes)
				text = text.replace(i, tmpPrototypes[i]);

			return text;
		}

		function fillVars(sTrans, vars) {
			if (sTrans != null) {
				var constSTrans = sTrans, m, regex = /(_|\$)\(\s*(?:"(.*?)"\s*,?)?\s*([^)]*)\s*\)/g;
				while ((m = regex.exec(constSTrans)) !== null)
					if (m[1] == '_' && typeof m[2] !== 'undefined')
						sTrans = sTrans.replace(m[0], i18n.trans(m[2].trim(), DeserializeVars(m[3], vars)));
					else if (m[1] == '$' && vars != null && (m[3] in vars))
						sTrans = sTrans.replace('$(' + m[3] + ')', vars[m[3]]);
			}
			return sTrans;
		}

		function DeserializeVars(serializedVars, vars) {
			if (serializedVars !== "" && vars != null && Object.keys(vars).length > 0) {
				var newVars = {}, varsList = serializedVars.split(',');
				for (var v in varsList) {
					v = v.trim();
					newVars[varsList[v]] = vars[varsList[v]];
				}
				return newVars;
			}
			return vars;
		}


		function pluralIndex(count) {
			return (count == 0) ? 0 : (count == 1 || count == -1) ? 1 : 2;
		}
	};
	i18n.i18nTrans = i18n.trans; // keep compatibility


	i18n.culture = function () {
		return $("#currentCulture").val();
	}

	//locale = les 2 premiers lettres de la culture
	i18n.locale = function () {
		var currentCulture = $("#currentCulture").val();
		var currentLocale = "fr";

		if (currentCulture && currentCulture.length) {
			currentLocale = currentCulture.substring(0, 2);
		}
		return currentLocale;
	}

	// https://en.wikipedia.org/wiki/Date_format_by_country
	// https://flatpickr.js.org/formatting/
	i18n.flatpickrDateFormat = function () {
		switch (i18n.locale()) {
			case "fr": return "d/m/Y";	// dd/mm/yyyy
			case "it": return "d/m/Y";	// dd/mm/yyyy
			case "en": return "m/d/Y";	// mm/dd/yyyy
			case "nl": return "d-m-Y";	// dd-mm-yyyy
		}

		// fr par default
		return "d/m/Y";	// dd/mm/yyyy
	}

	// https://en.wikipedia.org/wiki/Date_format_by_country
	// https://github.com/nosir/cleave.js/blob/master/doc/options.md#datepattern
	// https://github.com/nosir/cleave.js/blob/master/doc/options.md#delimiter
	i18n.cleaveDateFormat = function () {
		switch (i18n.locale()) {

			case "fr": return { datePattern: ['d', 'm', 'Y'], delimiter: '/' };	// dd/mm/yyyy
			case "it": return { datePattern: ['d', 'm', 'Y'], delimiter: '/' };	// dd/mm/yyyy
			case "en": return { datePattern: ['m', 'd', 'Y'], delimiter: '/' };	// mm/dd/yyyy
			case "nl": return { datePattern: ['d', 'm', 'Y'], delimiter: '-' };	// dd-mm-yyyy
		}

		// fr par default
		return { datePattern: ['d', 'm', 'Y'], delimiter: '/' };	// dd/mm/yyyy
	}


	window.global_i18nMissingKeys = function () {
		return console.log(Object.keys(_oMissingKeys)
			.map(function (x) { return _oMissingKeys[x]; })
			.map(function (x) { return x.key + "\t" + x.caller; })
			.join("\n"));
	}


	//en local, intercepte les appels à i18n qui n'ont pas de traduction
	var i18nProxy = null;
	if (window.Proxy && window.location.hostname == 'localhost') {

		function displayMessage(msg) {

			var panel = document.getElementById('missing_i18n_keys')
			if (!panel) {
				panel = document.createElement("div");
				panel.id = 'missing_i18n_keys';
				panel.style.position = "fixed";
				panel.style.top = 0;
				panel.style.right = 0;
				document.body.appendChild(panel);
			}

			var pre = document.createElement("pre");
			pre.textContent = msg + "\n\t...click to close";
			pre.style.marginBottom = "5px";
			pre.addEventListener('click', function () {
				panel.removeChild(pre);
				if (!panel.childElementCount) {
					document.body.removeChild(panel);
				}

			});


			panel.appendChild(pre);
		}

		function extractDirectCaller(sCallStack) {
			if (sCallStack) {
				var asLines = sCallStack.split("\n");
				//line 0 = 'Error'
				//line 1 = "at Object.get from i18n.js"
				//line 2 = relevant caller
				return asLines[2];

			}

			return '';
		}

		var fnShowMissingKeys = _.debounce(function () {
			var aoKeysNotShown = [];
			for (var key in _oMissingKeys) {
				var oCall = _oMissingKeys[key];
				if (!oCall.bShown) {
					aoKeysNotShown.push(oCall);
					//marque la propriété comme affichée dans les erreurs
					oCall.bShown = true;;
				}
			}

			if (aoKeysNotShown.length) {
				console.log("Missing i18n keys :\n", aoKeysNotShown.map(function (x) { return x.key + "\t" + x.caller }).join("\n"));

				var msg = "Missing i18n keys :\n" + _.take(aoKeysNotShown, 5).map(function (x) { return x.key }).join("\n");
				if (aoKeysNotShown.length > 5) {
					msg + "\n(" + (aoKeysNotShown.length - 5) + " more in console)";
				}

				displayMessage(msg);
			}

		}, 500, { trailing: true });

		i18nProxy = new Proxy(i18n,
			{
				get: function (target, name, receiver) {
					if (name in target) {
						return target[name];
					}

					if (!(name in _oMissingKeys)) {
						//extract caller
						var sCaller = extractDirectCaller(new Error().stack);


						_oMissingKeys[name] = { key: name, bShown: false, caller: sCaller };
					}

					fnShowMissingKeys();

					return undefined;
				}
			});
	}

	return i18nProxy || i18n;
});
